module.exports = __webpack_public_path__ + "img/RDA_tipo2_flexi-6pax_90m2.8e91fff2.png";